<style>
  .v-toolbar.v-toolbar--absolute {

    z-index: 0 !important;
  }
</style>

<template>
  <div>
    <vue-headful
      title="Catálogo Digital | Editora do Brasil"
      description="Catálogo Digital da Editora do Brasil"
    />
    <div class="embed-responsive">
      <!--<iframe class="embed-responsive-item" :src="urlIframe" allowfullscreen></iframe> -->
      <a :href='urlIframe'
    class="fbp-embed" data-fbp-lightbox="yes" data-fbp-width="100%" data-fbp-height="100%"
    style="max-width: 100%"></a>
			<!-- <VueScriptComponent script='<script async defer
    src="./../assets/js/embed.js"> -->
      <VueScriptComponent script='<script async defer
    src="https://conteudos.editoradobrasil.com.br/pnldlivrodigital/embed.js">
    </script>'/>
    </div>
  </div>
</template>

<script>
//import Embed from '../assets/embed.js'
import VueScriptComponent from "./../../node_modules/vue-script-component";
export default {
  name: "flippingbook",
  data() {
    return {
      //id: 0,
      urlIframe: this.$route.query.id
      //urlIframe: 'https://www.editoradobrasil.com.br/conteudos/pnldlivrodigital/2018/fisica-em-contextos/1/index.html'
    };
  },
  created() {

    window.history.replaceState({}, document.title, "/" + "flippingbook");

  },
  methods: {
    getURL() {
      this.urlIframe = this.$route.query.id;
    }
  },
  components: {
    VueScriptComponent
  }
};
</script>
